import { useEffect, useState, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function PremiumSlider({ images }) {
    const [current, setCurrent] = useState(0);
    // Auto Slide
    useEffect(() => {
        if (!images || images.length === 0) return;

        const interval = setInterval(() => {
            setCurrent((prev) => {
                const next = prev + 1;
                return next >= images.length ? 0 : next;
            });
        }, 4000);

        return () => clearInterval(interval);
    }, [images]);

    const prevSlide = () => {
        setCurrent((prev) => (prev - 1 + images.length) % images.length);
    };

    const nextSlide = () => {
        setCurrent((prev) => (prev + 1) % images.length);
    };

    const thumbRef = useRef(null);

    const scrollThumbs = (direction) => {
        if (!thumbRef.current) return;

        const scrollAmount = 200; // adjust scroll distance

        thumbRef.current.scrollBy({
            left: direction === "left" ? -scrollAmount : scrollAmount,
            behavior: "smooth",
        });
    };
    return (
        <div className="w-full max-w-6xl mx-auto p-1">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl group">

                {/* Slides */}
                <div className="relative h-[400px] w-full">
                    {images.map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt="slide"
                            className={`absolute inset-0 w-full h-full object-cover transition-all duration-1000 ease-in-out
                ${index === current
                                    ? "opacity-100 scale-100 z-10"
                                    : "opacity-0 scale-105 z-0"
                                }`}
                        />
                    ))}
                </div>

                {/* Arrows */}
                <button
                    onClick={prevSlide}
                    className="absolute left-6 top-1/2 -translate-y-1/2 z-20
             bg-black/40 hover:bg-black/60
             text-white p-3 rounded-full
             backdrop-blur-md shadow-xl
             transition-all duration-300"
                >
                    <ChevronLeft size={28} />
                </button>

                <button
                    onClick={nextSlide}
                    className="absolute right-6 top-1/2 -translate-y-1/2 z-20
             bg-black/40 hover:bg-black/60
             text-white p-3 rounded-full
             backdrop-blur-md shadow-xl
             transition-all duration-300"
                >
                    <ChevronRight size={28} />
                </button>

                {/* Dots */}
                <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-3">
                    {images.map((_, index) => (
                        <button
                            key={index}
                            onClick={() => setCurrent(index)}
                            className={`w-3 h-3 rounded-full transition-all duration-300
                ${index === current
                                    ? "bg-white scale-125"
                                    : "bg-white/50"
                                }`}
                        />
                    ))}
                </div>
            </div>

            {/* Thumbnails */}
            <div className="relative mt-2 h-[80px] flex items-center">

                {/* Left Scroll Button */}
                <button
                    onClick={() => scrollThumbs("left")}
                    className="absolute left-0 top-1/2 -translate-y-1/2 z-20
               bg-black/40 text-white p-2 rounded-full
               shadow-md hover:bg-black/70 transition"
                >
                    <ChevronLeft size={20} />
                </button>

                {/* Scrollable Thumbnails */}
                <div
                    ref={thumbRef}
                    className="flex gap-2 py-2 overflow-x-auto overflow-y-hidden
             scroll-smooth px-10 items-center
             scrollbar-hide"
                >
                    {images.map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt="thumb"
                            onClick={() => setCurrent(index)}
                            className={`min-w-[100px] h-[50px] object-cover rounded-xl cursor-pointer transition-all duration-300
          ${index === current
                                    ? "ring-4 ring-blue-500 scale-105"
                                    : "opacity-70 hover:opacity-100"
                                }`}
                        />
                    ))}
                </div>

                {/* Right Scroll Button */}
                <button
                    onClick={() => scrollThumbs("right")}
                    className="absolute right-0 top-1/2 -translate-y-1/2 z-20
               bg-black/40 text-white p-2 rounded-full
               shadow-md hover:bg-black/70 transition"
                >
                    <ChevronRight size={20} />
                </button>
            </div>
        </div>
    );
}